/* eslint-disable import/no-extraneous-dependencies */
import { Box } from "@mui/system";
import { useState, useRef } from "react";
import PropTypes from "prop-types";
import ReactCrop from "react-image-crop";
import PrimaryButton from "./PrimaryButton";
import "react-image-crop/dist/ReactCrop.css";

const ImageCropper = ({ selectedImage, setCroppedAreaPixels, createCroppedImage, setCropOpen }) => {
  const [crop, setCrop] = useState(null);
  const imgRef = useRef(null);

  const onImageLoad = (e) => {
    const img = e.currentTarget;
    imgRef.current = img;

    setCrop({
      unit: "%",
      x: 0,
      y: 0,
      width: 100,
      height: 100,
    });
  };

  const onCropComplete = (c) => {
    if (!imgRef.current || !c?.width || !c?.height) return;

    const img = imgRef.current;

    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;

    const area = {
      x: c.x * scaleX,
      y: c.y * scaleY,
      width: c.width * scaleX,
      height: c.height * scaleY,
    };

    setCroppedAreaPixels(area);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Box
        sx={{
          width: "90vw", // responsive width
          maxWidth: 500,
          maxHeight: "80vh", // allow vertical images to fit the screen
          position: "relative",
          overflow: "hidden",
        }}>
        <ReactCrop
          crop={crop}
          onChange={(c) => setCrop(c)}
          onComplete={onCropComplete}
          keepSelection
          minWidth={20}
          minHeight={20}
          aspect={undefined} // allow free aspect ratio
        >
          <img
            src={selectedImage}
            alt="crop-img"
            onLoad={onImageLoad}
            style={{
              width: "100%",
              height: "auto", // important for vertical images
              maxHeight: "80vh", // limit max height to viewport
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
            }}
          />
        </ReactCrop>
      </Box>

      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <PrimaryButton onClick={() => setCropOpen(false)}>Cancel</PrimaryButton>
        <PrimaryButton onClick={createCroppedImage}>Save</PrimaryButton>
        <PrimaryButton onClick={() => setCropOpen(false)}>Save without Crop</PrimaryButton>
      </Box>
    </Box>
  );
};

ImageCropper.propTypes = {
  selectedImage: PropTypes.string.isRequired,
  setCroppedAreaPixels: PropTypes.func.isRequired,
  createCroppedImage: PropTypes.func.isRequired,
  setCropOpen: PropTypes.func.isRequired,
};

export default ImageCropper;
